import React, { useCallback, useEffect, useRef } from 'react';

import { Mask, Overlay } from './styles';

interface CutOutOverlayProps {
    highlightElement: string;
    onClose: () => void;
}
const CutOutOverlay = ({ highlightElement, onClose }: CutOutOverlayProps) => {
    const borderRadius = 20;
    const cut = useRef<SVGRectElement>(null);

    const setPosition = useCallback(() => {
        const el = document.querySelector(`.${highlightElement}`);
        const box = el?.getBoundingClientRect();

        if (cut.current && box) {
            cut.current.setAttribute('x', `${box.left - 10}`);
            cut.current.setAttribute('y', `${box.top - 10}`);
            cut.current.setAttribute('width', `${box.width + 20}`);
            cut.current.setAttribute('height', `${box.height + 20}`);
        }
    }, [highlightElement]);

    useEffect(() => {
        return () => {
            window.removeEventListener('scroll', setPosition);
            window.removeEventListener('resize', setPosition);
        };
    }, [setPosition]);

    useEffect(() => {
        window.addEventListener('scroll', setPosition);
        window.addEventListener('resize', setPosition);
        setPosition();
    }, [highlightElement, cut, setPosition]);

    return (
        <Overlay
            onClick={onClose}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1.0, delay: 0.0 } }}
            exit={{ opacity: 0, transition: { duration: 0.6 } }}
        >
            <Mask>
                <svg width="100%" height="100%">
                    <defs>
                        <mask id="cut">
                            <rect x="0" y="0" width="100%" height="100%" fill="white" />
                            <rect ref={cut} className="cut" rx={borderRadius} ry={borderRadius} fill="black" />
                        </mask>
                    </defs>
                    <rect x="0" y="0" width="100%" height="100%" fill="rgba(42, 38, 55, 0.6)" mask="url(#cut)" />
                </svg>
            </Mask>
        </Overlay>
    );
};

export default CutOutOverlay;
